<template>
    <div class="loading-label">Loading...</div>
</template>

<script>
    export default {
        name: "TableLoader"
    }
</script>

<style scoped>
    .loading-label {
        position: absolute;
        bottom: 30px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        width: 210px;
        height: 40px;
        background: rgb(247, 183, 49);
        border-radius: 10px;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        color: #ffffff;
        box-shadow: 0px 2px 7px 0px #7a7a7a57;
        -webkit-box-shadow: 0px 2px 7px 0px #7a7a7a57;
        -moz-box-shadow: 0px 2px 7px 0px #7a7a7a57;
    }
</style>